/**
 * Gets leadform version from first element with the name `leadform`
 *
 * @param {HTMLElement} [elementScope=document] - Element to scope version search to
 * @param {string} [defaultValue=''] - Default value if `leadform` element can't be found
 * @return {string} Leadform version or `defaultValue` if not found
 */
export default function getLeadformVersion(elementScope = document, defaultVersion = '') {
  const versionField = elementScope.querySelector('[name="leadform"]');
  return (versionField && versionField.value) || defaultVersion;
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/metadata/get_leadform_version.js